import { render } from "./oap-make-the-switch-quiz.vue?vue&type=template&id=14d0bcf9"
import script from "./oap-make-the-switch-quiz.vue?vue&type=script&lang=js"
export * from "./oap-make-the-switch-quiz.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__